import { render, staticRenderFns } from "./Account4Add.vue?vue&type=template&id=cc22e658"
import script from "./Account4Add.vue?vue&type=script&lang=js"
export * from "./Account4Add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports